// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
import queryString from "query-string";
import NewAccount from "../../model/NewAccount";
const BASE_URI = "/accounts";

export default {
  /**
   * Gets all accounts from backend server
   * @param searchText
   * @param accountType
   */
  quicksearch(searchText: string, accountType: number) {
    const filter = {
      searchText: searchText,
      accountType: accountType,
    };
    const url = BASE_URI + "/quicksearch?" + queryString.stringify(filter);
    return backend.get(url);
  },

  /**
   * Creates a new account on the backend server
   * @param {object} newAccount - Account creation info
   * @returns {string} Account Id
   */
  createAccount(newAccount: NewAccount) {
    return backend.post(BASE_URI, newAccount, {
      showNotificationOnSuccess: true,
    });
  },

  /**
   * Gets the account reference data
   * @returns {object} - The account reference data
   */
  getReferenceData() {
    return backend.get("/accountreferencedata");
  },

  /**
   * Gets filtered accounts from backend server
   * @param searchText
   */
  search(searchText: string) {
    const filter = {
      searchText: searchText,
      pageSize: 20,
      pageNumber: 1,
    };
    return backend.post(BASE_URI + "/all", filter);
  },
};
